import type { RezaOpravneniDto } from '@gov-nx/api';
import type { FormatSubjectNameOptions } from '@gov-nx/utils/common';
import { formatSubjectName } from '@gov-nx/utils/common';

export const zastupujiciOsobaNazevPO = (
	person: RezaOpravneniDto['zastupujiciOsoba'],
	options?: FormatSubjectNameOptions
) => formatSubjectName(person?.pravnickaOsoba, options);

export const zastupujiciOsobaNazevFO = (
	person: RezaOpravneniDto['zastupujiciOsoba'],
	options?: FormatSubjectNameOptions
) => formatSubjectName(person?.fyzickaOsoba, options);

export const zastupujiciOsobaNazev = (
	{ zastupujiciOsobaTyp, zastupujiciOsoba }: RezaOpravneniDto,
	options?: FormatSubjectNameOptions
) =>
	formatSubjectName(
		zastupujiciOsobaTyp === 'PO'
			? zastupujiciOsoba?.pravnickaOsoba
			: zastupujiciOsoba?.fyzickaOsoba,
		options
	);
